import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "role_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref, reactive } from "vue";
import useRoute from "@util/router";
import $ from "@util/base";
import { $msg } from "@ui/msg";
import api from "@api/role";
export default {
  __name: 'RoleDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    const readOnly = ref(false);
    var title = "角色详情";
    const menuData = ref([]);
    getPermission();

    function changeStatus(e) {
      //e返回状态
      console.log(e); // let userId = row.userId;
      // let disable = row.disable;
      // axios.get(`http://xxxxx/xx?userId=${userId}&disable=${disable}`).then((res)=>{
      //   console.log(res);
      // })
    }

    function getPermission() {
      api.permission(val => {
        menuData.value = val;
        $.handleCRU(urlQuery.type, {
          show: () => {
            readOnly.value = true;
            title = "角色详情";
            getData();
          },
          add: () => {
            title = "新增角色";
          },
          modify: () => {
            title = "修改角色";
            getData();
          }
        });
      });
    }

    const shopLevelOptions = [{
      label: '总店',
      value: '1040001'
    }, {
      label: '分店',
      value: '1040002'
    }];
    const treeRef = ref('');
    const defaultProps = {
      children: 'children',
      label: 'title'
    };

    function getData() {
      api.details(route.query().code, val => {
        form.value.roleName = val.resultRole.name;
        form.value.shopLevel = val.resultRole.shopLevel;
        form.value.personalPerspective = val.resultRole.personalPerspective;

        if (val.resultRole.modifyFlag != 1) {
          readOnly.value = true;
        } // setCheckedKeys(val.resultRole.treeList.split(','))


        setCheckedKeys(val.permIds.split(','));
      });
    }

    const formRef = ref('');
    const form = ref({
      roleName: '',
      shopLevel: '',
      personalPerspective: 0,
      treeList: '',
      permissionList: []
    });
    const rules = {
      roleName: [{
        required: true,
        message: '请输入角色名称',
        trigger: 'blur'
      }],
      shopLevel: [{
        required: true,
        message: '请选择基地级别',
        trigger: 'blur'
      }],
      permissionList: [{
        required: true,
        type: 'array',
        message: '请勾选功能权限',
        trigger: 'blur'
      }]
    };

    function getAllTreeKeys() {
      let f = treeRef.value.getHalfCheckedKeys();
      let c = treeRef.value.getCheckedKeys(false);
      return f.concat(c);
    }

    function getCheckedKeys() {
      return treeRef.value.getCheckedKeys(false).join(',');
    }

    function setCheckedKeys(arr) {
      treeRef.value.setCheckedKeys(arr, false);
    }

    const checkForm = () => {
      // form.value.permissionList =  treeRef.value.getCurrentNode.map(val=>{
      //   return val.key
      // })
      // form.value.treeList = getCheckedKeys()
      form.value.permissionList = getAllTreeKeys(); // treeRef.value.getCheckedKeys(false)
      // console.log(treeRef.value.getCheckedKeys())
      // console.log(treeRef.value.getCheckedNodes())

      formRef.value.validate(valid => {
        if (valid) {
          $.handleCRU(route.query().type, {
            add: () => {
              addData();
            },
            modify: () => {
              modifyData();
            }
          });
        } else {
          return false;
        }
      });
    };

    function addData() {
      console.log("form.value" + JSON.stringify(form.value));
      api.add(form.value, () => {
        $msg.succ("添加成功");
        back();
      });
    }

    function modifyData() {
      api.update(route.query().code, form.value, () => {
        $msg.succ("修改成功");
        back();
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            rules: rules,
            disabled: readOnly.value,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "角色名称",
              prop: "roleName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.roleName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.roleName = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "基地级别",
              prop: "shopLevel"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: form.value.shopLevel,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.shopLevel = $event)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(shopLevelOptions, item => {
                  return _createVNode(_component_el_radio, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "个人视角"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: form.value.personalPerspective,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.personalPerspective = $event),
                "active-text": "开启",
                "active-value": "1",
                "inactive-value": "0"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "功能权限",
              prop: "permissionList"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tree, {
                ref_key: "treeRef",
                ref: treeRef,
                data: menuData.value,
                "show-checkbox": "",
                "default-expand-all": "",
                "node-key": "key",
                "highlight-current": "",
                props: defaultProps
              }, null, 8, ["data"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "disabled"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: checkForm,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};